/**
 * @generated SignedSource<<ddc9e515daefb7b73f61d48050c975b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type BjfBlockState = "ACTIVE" | "CLAIMABLE" | "CLAIMED" | "FINISHED" | "%future added value";
export type useBJFMiningSubscription$variables = {};
export type useBJFMiningSubscription$data = {
  readonly bjfMiningUpdated: {
    readonly progressId: number;
    readonly betTarget: number;
    readonly betProgress: number;
    readonly state: BjfBlockState;
    readonly finished: boolean;
    readonly miningAmount: number;
    readonly payedOut: string | null;
    readonly payoutPrice: string | null;
    readonly insertedAt: any;
    readonly updatedAt: any;
  };
};
export type useBJFMiningSubscription = {
  variables: useBJFMiningSubscription$variables;
  response: useBJFMiningSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BjfMiningRow",
    "kind": "LinkedField",
    "name": "bjfMiningUpdated",
    "plural": false,
    "selections": [
      {
        "alias": "progressId",
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "betTarget",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "betProgress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finished",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "miningAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payedOut",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payoutPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "insertedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBJFMiningSubscription",
    "selections": (v0/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useBJFMiningSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "dd2890e69bea1a76023739b3c083b39e",
    "id": null,
    "metadata": {},
    "name": "useBJFMiningSubscription",
    "operationKind": "subscription",
    "text": "subscription useBJFMiningSubscription {\n  bjfMiningUpdated {\n    progressId: id\n    betTarget\n    betProgress\n    state\n    finished\n    miningAmount\n    payedOut\n    payoutPrice\n    insertedAt\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c591f80a95c1428c70dd4babc747ff5";

export default node;
